// Modules
import { gql } from '@apollo/client'

export const ViewerSearchLoginByCPF = gql`
    query viewerSearchLoginByCPF($username: String!) {
        viewerSearchLoginByCPF(username: $username) {
            mobile
            email
        }
    }
`
